// @core/api/endpoints/document/update_document_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentPolicyResponse,
  UpdateDocumentPolicyRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update policy
 * Updates an existing document policy. Changes apply to new documents; existing documents keep their snapshotted settings.
 */
export async function UpdateDocumentPolicy(
  policy_id: string,
  data: UpdateDocumentPolicyRequest,
  options?: RequestOptions
): Promise<DocumentPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<DocumentPolicyResponse>(requestPath, data, requestOptions);
}
